export default {
  list: { lazy: () => import('./OrderingQuotes'), component: 'OrderingQuoteList' },
  options: {
    list: {
      title: 'Quotes List',
      breadCrumb: 'Quotes List',
    },
  },
}
